import type { FeatureRoutes } from '@/app/screens'

export default {
  screens: { assistant: () => import('./AskPage.vue') },
} satisfies FeatureRoutes
